export default "__VITE_ASSET__$rJNbT62__"